import alt from '../alt';
import uuid from 'uuid';
import CandidateActions from '../actions/CandidateActions';
import NotificationActions from '../actions/NotificationActions';
import ShiftStore from '../stores/ShiftStore';


class HiringActions {
    constructor() {
        this.generateActions(
            'getHiringSuccess', 'getLikeCandidatesSuccess', 'getCreateSuccess', 'resetCreated',
            'getDeleteSuccess', 'clearStatusError', 'clearStatusSuccess', 'resetDeleted', 'clearReloadPage');
    }

    getStatusChangeSuccess(response) {
        CandidateActions.updateCandidateHiring(response);
        ShiftStore.getShift(response.shift);
        this.dispatch(response);
    }

    getCreateFailed(response) {
        const errors = {
            400: "Cannot apply for that shift. The shift does not exist.",
            403: "Cannot apply for that shift. The shift has been filled or is cancelled."
        };
        const jsonErr = JSON.parse(response.responseText);
        const hiringError = {
            statusCode: response.statusCode,
            text: (jsonErr && jsonErr.detail) || errors[response.statusCode]
        };
        NotificationActions.showError(
            `Hiring:Error:${uuid.v4()}`,
            hiringError.text);
        this.dispatch(hiringError);
    }

    getDeleteFailed(response) {
        const errors = {
            403: "Cannot unapply for that shift. You have already been hired or decline.",
            404: "Cannot decline. Hiring doesn't exist."
        };
        const hiringError = {
            statusCode: response.statusCode,
            text: errors[response.statusCode]
        };
        NotificationActions.showError(
            `Hiring:Error:${uuid.v4()}`,
            hiringError.text);
        this.dispatch(hiringError);
    }

    getStatusChangeError(response) {
        const errors = {
            403: "Cannot hire candidate. Candidate belongs to another shift or something else is messed up",
            404: "Cannot hire candidate. Candidate decided to not apply or never applied"
        };
        const hiringError = {
            statusCode: response.statusCode,
            text: errors[response.statusCode]
        };
        NotificationActions.showError(
            `Hiring:Error:${uuid.v4()}`,
            hiringError.text);
        this.dispatch(hiringError);
    }
}

export default alt.createActions(HiringActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/HiringActions.js
 **/